import { useForm } from "react-hook-form"
import { SetURLSearchParams } from "react-router"
import { Button, Flex } from "antd"
import dayjs from "dayjs"
import { Invoice } from "types"

import { FilterFormValues } from "./schema"
import { DateInputField } from "ui/forms/fields/DateInputField"
import { CustomerField } from "ui/forms/fields/CustomerField"
import useFiltersFormDefaultValues from "./hooks/useFiltersFormDefaultValues"

interface FiltersProps {
  params: URLSearchParams
  setParamsCallback: SetURLSearchParams
  invoices: Invoice[]
}

const Filters = ({params, setParamsCallback, invoices = []}: FiltersProps) => {
  const filters = params.get('filters') || ''
  const defaultValues = useFiltersFormDefaultValues(invoices, filters)

  const { handleSubmit, control } = useForm<FilterFormValues>({
    defaultValues,
    mode: 'onChange',
    reValidateMode: 'onChange',
    criteriaMode: 'all',
  })

  const onSubmit = (data: FilterFormValues) =>{
    const filters = [
      (data?.startDate && { 
        field: 'date', 
        operator: 'gteq', 
        value: dayjs(data?.startDate).format('YYYY-MM-DD')
      }),
      (data?.endDate && { 
        field: 'date', 
        operator: 'lteq', 
        value: dayjs(data?.endDate).format('YYYY-MM-DD')
      }),
      (data?.customer && { 
        field: 'customer_id', 
        operator: 'eq', 
        value: data.customer.id
      }),
    ].filter(Boolean)

    params.set('filters', JSON.stringify(filters))
    setParamsCallback(params)
  }

  const handleResetFilters = () => {
    params.delete('filters')
    setParamsCallback(params)
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Flex gap="1rem" wrap="wrap">
        <Flex flex="auto">
          <div className="full-width">
            <CustomerField 
              label="Customer" 
              control={control} 
              name={'customer'} 
            />
          </div>
        </Flex>
        <Flex flex="auto">
          <div className="full-width">
            <DateInputField
              control={control}
              name={'startDate'}
              label={'Start date'}
              placeholder={'Select the start date'}
            />
          </div>
        </Flex>
        <Flex flex="auto">
          <div className="full-width">
            <DateInputField
              control={control}
              name={'endDate'}
              label={'End date'}
              placeholder={'Select the end date'}
            />
          </div>
        </Flex>
      </Flex>
      <Flex className='my-2'>
        <Button type="primary" htmlType="submit">
          Search
        </Button>
        <Button type="link" onClick={handleResetFilters}>
          Reset
        </Button>
      </Flex>
    </form>
  )
}

export default Filters